import React from "react";

export default () => (
  <small>
    <a href="https://app.inmatics.io/help">¿Necesitás ayuda?</a>
  </small>
);
